<template>
  <div class="search">
    <v-text-field
      v-model.trim="search"
      v-model="search"
      :placeholder="$t('COMMON.FILTER.SEARCH')"
      hide-details
      density="compact"
      @keydown.enter="sendSearch()"
      base-color="white"
      bg-color="white"
    >
      <template v-slot:append-inner>
        <v-btn @click="sendSearch()" variant="flat">
          {{ $t('COMMON.FILTER.SEARCH') }}
        </v-btn>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'SearchRepairFile',
  data() {
    return {
      search: ''
    }
  },
  methods: {
    sendSearch() {
      if (this.search !== '') {
        this.$router.push('/dashboard/repair-file?search=' + this.search)
      }
    }
  }
}
</script>

<style scoped>
.search {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 70px;
  border-radius: 20px;
  background-color: #efefef;
  padding: 0 20px;
}
</style>
